module.exports = __webpack_public_path__ + "static/ourrole_icon-34899d6311e1d5b8a7cb03a012f9d59a.svg";